import { Breadcrumb, Card, Layout, Menu, MenuProps, theme } from 'antd';
import { ProfileOutlined, RocketOutlined, UserOutlined } from '@ant-design/icons';

const { Header, Content, Footer } = Layout;


function About() {

  return (
      <p>Hello world! I am a software engineer who is passionate about education and tech for social good.
      I have strong backend skills and enjoy solving complex problems with efficient, thoughtful solutions in Python and Ruby.
      I also have experience with modern-day web frameworks, such as Django, Rails, and React. 
      My background in consulting and current role as a customer-facing engineer, have taught me to effectively collaborate with engineers, product, and customers alike.
      You'll regularly find me teaching Python in my free time.
      I am based in the Bay Area  🌁  </p>
    
  );
}

export default About;
